// handleRedirect.js
import { navigateTo } from "./navigation";

export function handleRedirect(status) {
  switch (status) {
    case 400:
      navigateTo("/error_400");
      break;
    
    case 404:
      navigateTo("/error_404");
      break;
    case 500:
      navigateTo("/error_500");
      break;
    case 503:
      navigateTo("/error_503");
      break;
    case 401:
      localStorage.removeItem("authToken");
      navigateTo("/login");
      break;
    case 403:
      navigateTo("/unauthorized");
      break;
    default:
      break;
  }
}
